import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null=checking, false=not auth, object=auth
  const token = localStorage.getItem("admin_token");

  useEffect(() => {
    if (!token) {
      setAdmin(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setAdmin(res.data))
      .catch(() => {
        localStorage.removeItem("admin_token");
        setAdmin(false);
      });
  }, [token]);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("admin_token", res.data.token);
    setAdmin(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("admin_token");
    setAdmin(false);
  };

  return <AuthContext.Provider value={{ admin, login, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
